const musicLinkUrlPartsES = {
    "view": {
        "table": {
            "title": "Tu lista de partes de URL de enlaces de música",
            "column": {
                "part": "Parte",
                "owner": "Propietario",
                "action": "Acción"
            },
            "placeholder": {
                "search": "Buscar..."
            },
            "button": {
                "exportCSV": "Exportar CSV"
            }
        },
        "message": {
            "success": "¡La parte de URL del enlace de música ha sido eliminada!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo.",
            "noUrlparts": "Actualmente, esta función solo se ofrece a algunos usuarios seleccionados, pero la buena noticia es que pronto también podrás usarla. ¡Sigue atento a este espacio!"
        },
        "modal": {
            "delete": {
                "header": "¿Eliminar {{mlUrlpart}}?",
                "body": "¿Estás seguro de que deseas eliminar esta parte de URL de enlace de música?"
            },
            "canNotDelete": {
                "header": "No se puede eliminar la parte de URL de enlace de música {{mlUrlPart}}",
                "body": "La parte de URL de enlace de música {{mlUrlPart}} no se puede eliminar ya que ya está asociada con un enlace de música."
            }
        }
    },
    "add": {
        "form": {
            "label": {
                "subUser": "Subusuario",
                "part": "Parte",
                "owner": "Propietario",
                "addUrlPart": "Agregar parte de URL",
                "editUrlPart": "Editar parte de URL"
            },
            "placeholder": {
                "subUser": "Seleccionar subusuario..."
            },
            "help_text": {
                "subUser": "Nota: Solo usa este menú desplegable si deseas agregar un enlace de música para alguno de tus subusuarios, de lo contrario, déjalo sin seleccionar."
            },
            "button": {
                "reset": "Restablecer",
                "submit": "Enviar"
            },
            "validation": {
                "part": {
                    "required": "La parte es obligatoria",
                    "max": "Debe tener exactamente 16 caracteres"
                }
            },
            "message": {
                "subUserLimit": "Este subusuario ha consumido el límite máximo de 10 partes de URL.",
                "urlPartAlreadyTaken": "Esta URL de enlace de música ya está tomada por tu cuenta o la cuenta de otro usuario. Por favor, intenta con otra cosa."
            }
        },
        "message": {
            "addSuccess": "¡La parte de URL del enlace de música ha sido añadida!",
            "updateSuccess": "¡La parte de URL del enlace de música ha sido actualizada!",
            "error": "¡Algo salió mal! Por favor, actualiza la página e inténtalo de nuevo."
        }
    }
};

export default musicLinkUrlPartsES;